import styled from "styled-components";

export const NotFoundWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    color: ${({ theme }) => theme.colors.primaria};
    font-size: 64px;
    font-weight: bold;
    & + span {
      font-size: 40px;
      font-weight: normal;
    }
    &.redirect {
      width: 424px;
      margin-top: 14px;
      font-size: 14px;

      a {
        font-size: 14px;
        color: currentColor;
        text-decoration: underline;
        font-weight: 700;
      }
    }
  }
`;
